<template>
  <sb-panel :variation="variation">
    <slot name="header" />
    <expand-transition overflow="visible" :overflow-el="$el" @leavecomplete="handleCollapseFinished">
      <slot v-if="!collapse"/>
    </expand-transition>
  </sb-panel>
</template>

<script>
import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'

export default {
  name: 'CollapsiblePanel',
  components: {},
  mixins: [],
  props: {
    variation: {
      type: String,
      default: 'default'
    },
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({}),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {},
  methods: {
    handleCollapseFinished () {
      if (this.$shipBobStore._modules.root._children[ModuleName]) this.$shipBobStore.dispatch(ModuleName + '/setStepCollapsed', true)
    }
  },
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style scoped lang='scss'>

</style>
